"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLoadingWrapper = exports.StyledListItem = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _shared = require("../../shared");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const DarkThemeCss = (0, _styledComponents.css)(["background:", ";background-image:linear-gradient( to right,", " 0%,#dfdee0 20%,", " 30%,", " 100% );"], _shared.theme.palette.ui.neutral.grey4, _shared.theme.palette.ui.neutral.grey4, _shared.theme.palette.ui.neutral.grey4, _shared.theme.palette.ui.neutral.grey4);
const LightThemeCss = (0, _styledComponents.css)(["background:", ";background-image:linear-gradient( to right,", " 0%,#e8eaed 20%,", " 30%,", " 100% );"], _shared.theme.palette.ui.neutral.grey5, _shared.theme.palette.ui.neutral.grey5, _shared.theme.palette.ui.neutral.grey5, _shared.theme.palette.ui.neutral.grey5);
const listItem = new Map();
listItem.set('light', LightThemeCss);
listItem.set('dark', DarkThemeCss);
const loading = (0, _styledComponents.keyframes)(["0%{background-position:-468px 0;}100%{background-position:468px 0;}"]);

const StyledLoadingWrapper = _styledComponents.default.div.withConfig({
  displayName: "LoadingScreenstyles__StyledLoadingWrapper",
  componentId: "sc-h9f53i-0"
})(["width:100%;display:flex;background:transparent;flex-direction:column;overflow:hidden;"]);

exports.StyledLoadingWrapper = StyledLoadingWrapper;

const StyledListItem = _styledComponents.default.div.withConfig({
  displayName: "LoadingScreenstyles__StyledListItem",
  componentId: "sc-h9f53i-1"
})(["box-sizing:border-box;width:", ";height:", ";border-radius:", ";", ";", ";background-repeat:no-repeat;background-size:800px 104px;animation:", " 1s linear infinite forwards;"], ({
  width
}) => width && width, ({
  height
}) => height ? height : '16px', ({
  radius
}) => radius ? radius : '60px', ({
  theme
}) => listItem.get(theme), ({
  loaderColor,
  theme
}) => loaderColor && `
			background: ${loaderColor};
			background-image: linear-gradient(
				to right,
				${loaderColor} 0%,
				${theme === 'dark' ? '#dfdee0' : '#e8eaed'} 20%,
				${loaderColor} 30%,
				${loaderColor} 100%
			);
		`, loading);

exports.StyledListItem = StyledListItem;